export default {
  userAddedProductToInventory: '{creator} محصول {product} را وارد انبار کرد ',
  userIncreasedProductInInventory:
    '{creator} موجودی محصول {product} را افزایش داد',
  userDeductedProductFromInventory:
    '{creator} محصول {product} را از انبار خارج کرد',
  productDeductedByFactor:
    'محصول {product} از طریق شماره فاکتور {invoice} از انبار خارج شد',
  userCreatedWarehouse: '{creator} انبار{warehouse} را ایجاد کرد',
  userUpdatedWarehouse: '{creator}{field} انبار را به {value} تغییر داد',
};
